// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hxAgSPyMVJejJSgKqH0u {
	all: unset;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	height: 56px;
	padding: 0 40px;
	-webkit-user-select: none;
	   -moz-user-select: none;
	        user-select: none;
	border-radius: 12px;
	cursor: pointer;
	white-space: nowrap;
}
.hxAgSPyMVJejJSgKqH0u.MmoGx72aA2lrsRp64Npg {
		width: 100%;
	}
/* Colors */
.hxAgSPyMVJejJSgKqH0u.VyoYNbTd_nEn0XEyDPQM {
		background-color: var(--white);
		color: var(--black);
	}
.hxAgSPyMVJejJSgKqH0u.VhyomWACiCkJH9ht2hYS {
		background-color: var(--black);
		color: var(--brand);
	}
/* Sizes */
.hxAgSPyMVJejJSgKqH0u.AfpyY08pTe0imfsaTeVG {
		height: 40px;
		padding: 0 20px;
		border-radius: 6px;
		color: var(--gray3);
	}
.hxAgSPyMVJejJSgKqH0u:disabled {
		cursor: default;
		background-color: var(--gray2);
		color: var(--gray3);
	}
@media (max-width: 767px) {
	.hxAgSPyMVJejJSgKqH0u {
		height: 40px;
}
	}
`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.pcss"],"names":[],"mappings":"AAEA;CACC,UAAU;CACV,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;CACT,YAAY;CACZ,eAAe;CACf,yBAAiB;IAAjB,sBAAiB;SAAjB,iBAAiB;CACjB,mBAAmB;CACnB,eAAe;CACf,mBAAmB;AAkCpB;AAhCC;EACC,WAAW;CACZ;AAEA,WAAW;AACX;EACC,8BAA8B;EAC9B,mBAAmB;CACpB;AAEA;EACC,8BAA8B;EAC9B,mBAAmB;CACpB;AAEA,UAAU;AACV;EACC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;CACpB;AAEA;EACC,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;CACpB;AAEA;CA1CD;EA2CE,YAAY;AAEd;CADC","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.button {\n\tall: unset;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 10px;\n\theight: 56px;\n\tpadding: 0 40px;\n\tuser-select: none;\n\tborder-radius: 12px;\n\tcursor: pointer;\n\twhite-space: nowrap;\n\n\t&.block {\n\t\twidth: 100%;\n\t}\n\n\t/* Colors */\n\t&.white {\n\t\tbackground-color: var(--white);\n\t\tcolor: var(--black);\n\t}\n\n\t&.black {\n\t\tbackground-color: var(--black);\n\t\tcolor: var(--brand);\n\t}\n\n\t/* Sizes */\n\t&.size-S {\n\t\theight: 40px;\n\t\tpadding: 0 20px;\n\t\tborder-radius: 6px;\n\t\tcolor: var(--gray3);\n\t}\n\n\t&:disabled {\n\t\tcursor: default;\n\t\tbackground-color: var(--gray2);\n\t\tcolor: var(--gray3);\n\t}\n\n\t@media (--mobile) {\n\t\theight: 40px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `hxAgSPyMVJejJSgKqH0u`,
	"block": `MmoGx72aA2lrsRp64Npg`,
	"white": `VyoYNbTd_nEn0XEyDPQM`,
	"black": `VhyomWACiCkJH9ht2hYS`,
	"size-S": `AfpyY08pTe0imfsaTeVG`,
	"sizeS": `AfpyY08pTe0imfsaTeVG`
};
export default ___CSS_LOADER_EXPORT___;
